<template>
    <div class="plan-strategy-step-1 plan-strategy-step-2">
        <!-- <a target="_blank" rel="noopener noreferrer" class="btn" href="https://youtu.be/1MWwjAutl7o?t=215">HELP: how to use the STRATEGY page...</a> -->
        <pillars />
        <keywords />
    </div>
</template>

<script>
import pillars from '../../components/plannervid/strategy/pillars'
import keywords from '../../components/plannervid/strategy/keywords'

export default {
  components: {
    pillars,
    keywords,
  },
  mounted() {
    // this.$tours['plan-strategy'].start()
  },
}
</script>
